import Notiflix from "notiflix-react";

export default Notiflix.Notify.Init({
  width: "auto",
  useIcon: false,
  useGoogleFont: true,
  distance: "25px",
  fontFamily: "Noto Sans KR",
  useFontAwesome: false,
  fontAwesomeIconSize: "24px",
  cssAnimationStyle: "from-top",
  borderRadius: "20px",
  fontSize: "13px",
  timeout: 1000,
  success: {
    background: "rgba(24, 12, 12, 1)",
    textColor: "#fff",
    fontAwesomeClassName: "fas fa-times",
    fontAwesomeIconColor: "rgba(0,0,0,0.2)"
  },
  failure: {
    background: "rgba(24, 12, 12, 1)",
    textColor: "#fff",
    fontAwesomeClassName: "fas fa-times",
    fontAwesomeIconColor: "rgba(0,0,0,0.2)"
  }
});
